var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.4218 2.84676C6.4218 3.91585 5.62993 4.65774 4.80178 4.65774C3.97364 4.65774 3.18177 3.91585 3.18177 2.84676C3.18177 1.77766 3.97364 1.03578 4.80178 1.03578C5.62993 1.03578 6.4218 1.77766 6.4218 2.84676ZM4.80165 10.9642C3.5457 10.9642 2.49642 10.7941 1.80208 10.5071C1.08346 10.21 1.03578 9.93617 1.03578 9.83237C1.03578 9.59319 1.2529 9.0852 1.99397 8.57469C2.69022 8.09505 3.68575 7.74301 4.80165 7.74301C5.91754 7.74301 6.91316 8.09506 7.60949 8.57471C8.35065 9.08525 8.56778 9.59324 8.56778 9.83237C8.56778 9.93611 8.52011 10.2099 7.80137 10.507C7.10695 10.7941 6.05759 10.9642 4.80165 10.9642Z",
    fill: "#0A51C5",
    stroke: "#0A51C5",
    strokeWidth: 2.07155
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40099 5.09537C8.24603 5.09537 8.14373 5.00609 8.09604 4.87823C8.04762 4.74841 8.05675 4.57988 8.13068 4.43327C8.36878 3.9611 8.50385 3.42072 8.50385 2.84676C8.50385 2.31556 8.38816 1.81313 8.18218 1.36692C8.13407 1.26269 8.13549 1.1465 8.176 1.05781C8.2159 0.970435 8.2929 0.910323 8.40099 0.910323C9.47496 0.910323 10.3504 1.84444 10.3504 3.00285C10.3504 4.16126 9.47496 5.09537 8.40099 5.09537ZM11.9588 8.23873C11.9588 8.63709 11.7369 8.96034 11.3466 9.2102C11.2073 9.29934 11.0511 9.2862 10.9085 9.20795C10.765 9.12921 10.6392 8.98596 10.5695 8.82455C10.2338 8.04719 9.43737 7.29806 8.3735 6.78545C8.14151 6.67366 8.0261 6.4566 8.03027 6.27152C8.03234 6.17934 8.06388 6.0965 8.12346 6.03687C8.18272 5.97755 8.27338 5.93756 8.40086 5.93756C9.38633 5.93755 10.278 6.24674 10.9224 6.69066C11.5687 7.13582 11.9588 7.71054 11.9588 8.23873Z",
    fill: "#0A51C5",
    stroke: "#0A51C5",
    strokeWidth: 0.0823716
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.ce4f270a2df2bb0bcd63c593e0ff836a.svg";
export { ForwardRef as ReactComponent };